// extracted by mini-css-extract-plugin
export var banner = "slider-module--banner--mPstW";
export var container = "slider-module--container--6Wmz5";
export var dots = "slider-module--dots--ahg6X";
export var next = "slider-module--next--X7qXu";
export var noNavButtons = "slider-module--no-nav-buttons--szDAO";
export var prev = "slider-module--prev--6IgS1";
export var slider = "slider-module--slider--IYycM";
export var small = "slider-module--small--2ux9h";